import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

//styles
import { linkColor, mainColor } from "../../../styles/theme";

const BreadcrumbWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
  padding: 0 10px;

  .breadcrumb-link {
    cursor: pointer;
    color: ${linkColor};

    &.current-page {
      cursor: default;
      color: ${mainColor};
    }
  }

  .sep {
    margin: 0 13px;
  }
`;

const sep = (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="sep"
  >
    <path
      d="M0.590088 10.58L5.17009 6L0.590088 1.41L2.00009 0L8.00009 6L2.00009 12L0.590088 10.58Z"
      fill={linkColor}
    />
  </svg>
);

type Path = {
  id: number;
  name: string;
};
interface Props {
  data: Path[];
}

const Breadcrumb: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BreadcrumbWrapper>
      <div
        className="breadcrumb-link"
        onClick={() => navigate("/")}
      >
        {t("common.begin")}
      </div>
      {sep}
      {data.map((item: Path, i: number) => (
        <React.Fragment key={i}>
          {i === 0 ? (
            <div
              className={`breadcrumb-link${i === data.length - 1 ? " current-page" : ""}`}
              onClick={() => navigate(`/categories/${item.id}`)}
            >
              {item.name}
            </div>
          ) : (
            <div
              className={`breadcrumb-link${i === data.length - 1 ? " current-page" : ""}`}
              onClick={() => navigate(`/categories/${data[0].id}/${item.id}`)}
            >
              {item.name}
            </div>
          )}
          {i < data.length - 1 && sep}
        </React.Fragment>
      ))}
    </BreadcrumbWrapper>
  );
};

export default Breadcrumb;
